<div
  [ngStyle]="{ 'background-image': 'url(' + backgroundImage + ')' }"
  class="landing-container"
>
  <app-nav />
  <app-search />
</div>
<div class="tool-section">
  <app-info-box class="tool-section-item" title="About this Tool"
    ><p>
      The Title X Family Planning Clinic Locator provides information about
      clinics that offer a broad range of family planning and preventive health
      services. In addition to family planning services, Title X clinics also
      provide essential preventive health services that benefit reproductive
      health. These services include HPV vaccination, provision of HIV
      pre-exposure prophylaxis (PrEP), breast and cervical cancer screening, and
      screening for obesity, smoking, drug and alcohol use, mental health, and
      intimate partner violence.
    </p></app-info-box
  >
  <app-info-box class="tool-section-item" title="Host this Tool"
    ><p>
      OPA has developed a Family Planning Clinic Locator widget to allow other
      websites to host this tool.
    </p>
    <p>
      <a class="underline-link" [routerLink]="['/host-this-tool']"
        >Host this tool on your organization's website</a
      >
      to help people in your community find a Title X family planning clinic
      near them.
    </p></app-info-box
  >
</div>
